import BulkEditShipmentContainer from "./BulkEditShipmentContainer";
export default BulkEditShipmentContainer;
